// Mock data for Valley Mills replica

export const NAV_LINKS = [
  { label: 'The Development', href: '#development' },
  { label: 'Location', href: '#location' },
  { label: 'Trade & Industrial', href: '#trade' },
  { label: 'Offices', href: '#offices' },
  { label: 'Availability', href: '#availability' },
];

export const INFO_BAR = [
  { title: '151 KENT ROAD', subtitle: 'PUDSEY, LEEDS · LS28 9NF', icon: 'MapPin' },
  { title: 'EXCELLENT ACCESS', subtitle: 'LEEDS · BRADFORD · M62', icon: 'Train' },
  { title: 'SUSTAINABLE UPGRADES', subtitle: 'EPC B/C+ · FIBRE · EV', icon: 'Leaf' },
  { title: 'WORK', subtitle: 'SPACE FOR PRODUCTIVITY', icon: 'Zap' },
  { title: 'CREATE', subtitle: 'SPACE FOR AMBITION', icon: 'TrendingUp' },
  { title: 'GROW', subtitle: 'SPACE FOR SUCCESS', icon: 'Users' },
];

export const DEVELOPMENT_ITEMS = [
  '3 Trade Counter / Light Industrial Units',
  '8 Modern Office Suites',
  'Contemporary reception areas',
  'Landscaped external areas',
  'Secure managed estate',
  'Excellent on-site parking',
];

export const LOCATION_TIMES = [
  { time: '15 min', place: 'Leeds City Centre' },
  { time: '15 min', place: 'Bradford' },
  { time: '10 min', place: 'M621' },
  { time: '15 min', place: 'M62' },
];

export const FEATURES = [
  { title: 'High Speed Fibre', desc: 'Business-grade connectivity throughout.', icon: 'Wifi' },
  { title: 'EPC B/C+', desc: 'Modern envelope, low running costs.', icon: 'Gauge' },
  { title: 'EV Charging', desc: 'On-site EV provision for occupiers.', icon: 'Plug' },
  { title: 'Heating & Cooling', desc: 'Modern M&E across every unit.', icon: 'Thermometer' },
  { title: 'Contemporary Kitchens', desc: 'Considered communal & private prep areas.', icon: 'UtensilsCrossed' },
  { title: 'Luxury Washrooms', desc: 'Hotel-grade fittings and finishes.', icon: 'Droplets' },
  { title: 'LED Lighting', desc: 'Energy-efficient, daylight-tuned.', icon: 'Lightbulb' },
  { title: 'Secure Access', desc: 'Managed, gated commercial estate.', icon: 'ShieldCheck' },
  { title: 'High Quality Finishes', desc: 'Uncompromising specification throughout.', icon: 'Layers' },
];

export const TRADE_BENEFITS = [
  'Electric roller shutter doors',
  'Customer parking',
  'High internal ceilings',
  'Office accommodation',
  'Kitchen & WC facilities',
  'Excellent loading access',
];

export const TRADE_SUITED = [
  'Building Merchants',
  'Electrical & Plumbing Suppliers',
  'Kitchens & Bathrooms',
  'Flooring',
  'Joinery',
  'Engineering',
  'Distribution',
  'Automotive Specialists',
  'E-commerce',
  'Storage & Logistics',
];

export const OFFICE_FEATURES = [
  'Contemporary finishes',
  'Meeting facilities',
  'Kitchenettes',
  'Secure access',
  'Abundant natural daylight',
  'Flexible open-plan layouts',
  'High speed internet',
];

export const OFFICE_IDEAL = [
  'Architects', 'Surveyors', 'Property Professionals', 'Financial Services',
  'Marketing Agencies', 'Consultants', 'Recruitment', 'Technology Companies', 'Healthcare Professionals',
];

export const AVAILABILITY = [
  { unit: 'Unit A1', type: 'Trade / Industrial', category: 'trade', size: '2,140', desc: 'Corner trade counter unit with excellent visibility from Kent Road.', status: 'Available' },
  { unit: 'Unit A2', type: 'Trade / Industrial', category: 'trade', size: '1,450', desc: 'Versatile light industrial unit suited for trade or distribution.', status: 'Available' },
  { unit: 'Unit A3', type: 'Trade / Industrial', category: 'trade', size: '950', desc: 'Compact trade counter unit ideal for growing merchants.', status: 'Under Offer' },
  { unit: 'Suite 101', type: 'Office Suite', category: 'offices', size: '450', desc: 'South-facing office suite with restored heritage windows.', status: 'Available' },
  { unit: 'Suite 102', type: 'Office Suite', category: 'offices', size: '620', desc: 'Open-plan office with meeting nook and mill views.', status: 'Available' },
  { unit: 'Suite 103', type: 'Office Suite', category: 'offices', size: '785', desc: 'Corner office suite with abundant natural daylight.', status: 'Available' },
  { unit: 'Suite 201', type: 'Office Suite', category: 'offices', size: '940', desc: 'Premium first-floor suite with exposed brick and beams.', status: 'Let' },
  { unit: 'Suite 202', type: 'Office Suite', category: 'offices', size: '1,120', desc: 'Flexible open layout, dividable for growing teams.', status: 'Available' },
  { unit: 'Suite 203', type: 'Office Suite', category: 'offices', size: '1,380', desc: 'Signature office with skylight and executive layout.', status: 'Available' },
  { unit: 'Suite 204', type: 'Office Suite', category: 'offices', size: '1,610', desc: 'Large open-plan suite ideal for established professional teams.', status: 'Under Offer' },
  { unit: 'Suite 301', type: 'Office Suite', category: 'offices', size: '2,100', desc: 'Flagship top-floor suite with panoramic light and premium finishes.', status: 'Available' },
];

export const SUSTAINABILITY = [
  'Energy efficient refurbishment',
  'Improved building insulation',
  'LED lighting throughout',
  'EV charging infrastructure',
  'Improved thermal performance',
  'Modern mechanical systems',
];

export const WORKS = [
  'Complete roof refurbishment',
  'New glazing throughout',
  'Modern mechanical & electrical installations',
  'Air conditioning',
  'Contemporary office finishes',
  'Premium flooring',
  'External landscaping',
  'Improved parking',
  'New entrances and reception areas',
];

export const FUTURE_GROWTH = [
  'Additional industrial accommodation',
  'Expanded commercial space',
  'Enhanced estate facilities',
  'Continued investment throughout the site',
];

export const IMAGES = {
  logo: '/images/logo.png',
  hero: '/images/hero-hoarding.png',
  brick: '/images/mill-interior.png',
  leeds: '/images/mill-interior.png',
  office: '/images/office-atrium.png',
  hallway: '/images/hallway.png',
};
